module.exports = __webpack_public_path__ + "img/3.64144e78.png";